export const CURATION_EDITOR_ACTIONS = {
  'REVISE':'REVISE',
  'SAVE':'SAVE',
  'PUBLISH':'PUBLISH',
  'APPROVE':'APPROVE',
  'ARCHIVE':'ARCHIVE',
  'SUBMIT_FOR_APPROVAL':'SUBMIT_FOR_APPROVAL',
  'SUBMIT_FOR_REVIEW':'SUBMIT_FOR_REVIEW',
  'REJECT':'REJECT',
  'REJECT_ARCHIVING':'REJECT_ARCHIVING',
  'DISCARD':'DISCARD',
  'EDIT':'EDIT'
};
